import { type FC } from "react";
import { Typography } from "@mui/material";
import LoginButton from "../../components/LoginButton";
import { useAuth0 } from "@auth0/auth0-react";
import { ChatsList } from "./ChatsList";
import { useTypedSelector } from "../../redux/store";

export const Chats: FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const userJwt = useTypedSelector((state) => state.auth.value);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingTop: 20,

        flexDirection: "column",
        alignItems: "center"
      }}
    >
      {!userJwt && !isAuthenticated ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            margin: "15px 10px 30px"
          }}
        >
          <Typography color={"#d5d5d5"}>
            To view or send messages, please log in first.
          </Typography>
          <LoginButton loginWithRedirect={loginWithRedirect} />
        </div>
      ) : (
        <ChatsList />
      )}
    </div>
  );
};
